<form [formGroup]="form" class="mt-1">
  <ng-template #tipContent let-tooltipMsg="tooltipMsg">{{tooltipMsg}}</ng-template>
  <div class="formula-variable-container" *ngFor="let formulaVarName of getFormulaVariableNames(false)">
    <div class="formula-variable-content mt-1 mb-1" [ngClass]="{'dirty-entry': form.get(formulaVarName).dirty}" padding>

      <!-- Name input and buttons row -->
      <div class="name-and-buttons-row">
        <div class="input-group name-input-group">
          <span class="input-group-addon">Name</span>
          <input
            [value]="formulaVarName"
            id="{{formulaVarName}}"
            name="{{formulaVarName}}"
            [formControlName]='formulaVarName'
            [ngbTooltip]="tipContent" triggers="manual" #tt="ngbTooltip"
            (change)="onCheckForTooltip(tt, form.get(formulaVarName))"
            (keyup)="onCheckForTooltip(tt, form.get(formulaVarName))"
            (keydown)="onNameKeyDown($event, formulaInputEl, formulaVarName)"
            class="form-control"
            #formulaInputEl
          >
        </div>

        <div class="buttons-group">
          <button
            class="btn btn-success"
            [disabled]="(form.get(formulaVarName).errors || form.get(formulaVarName + 'Expression').errors || !form.dirty)  ? true : null"
            (click)="onEdit(formulaInputEl.value, formulaVarName)"
          >
            <i class="fa fa-save"></i>
          </button>
          <button class="btn btn-primary ml-1" (click)="onUndo(formulaVarName)">
            <i class="fa fa-undo"></i>
          </button>
          <button class="btn btn-danger ml-1" (click)="onRemove(formulaVarName)">
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>

      <!-- Formula textarea row -->
      <div class="formula-textarea-row">
        <div>
          <span class="formula-top-label">{{_(KEYS.EDITOR.FORMULA)}}</span>
          <textarea
            [formControlName]='formulaVarName + "Expression"'
            [ngbTooltip]="tipContent" triggers="manual" #ttd="ngbTooltip"
            (change)="onCheckForTooltip(ttd, form.get(formulaVarName + 'Expression'))"
            (keyup)="onCheckForTooltip(ttd, form.get(formulaVarName + 'Expression'))"
            (keydown)="onExpressionKeyDown($event, formulaInputEl, formulaVarName)"
            class="form-control expression-textarea"
            rows="2"
          ></textarea>
        </div>
      </div>

    </div>
  </div>
</form>

<div class="input-group mt-2 mb-2">
  <span class="input-group-addon">{{_(KEYS.EDITOR.ADD_FORMULA_VARIABLE)}}</span>
  <button
    class="btn input-group-addon add-btn btn-success add-btn"
    (click)="onAdd()">
    <i class="fa fa-plus"></i>
  </button>
</div>
